import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'calsoft-specific-info-product',
  templateUrl: './specific-info-product.component.html',
  styleUrls: ['./specific-info-product.component.scss']
})
export class SpecificInfoProductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

 @Input() prescriptionRequired:any;
 @Input()product: any;
 @Input()factBox: any;
 @Input() faq: any;
 @Input() SIDEEFFECTS: any=[];
 @Input() Commonsideeffects: any=[];
 @Input()SafetyAdvice:any;
 @Input()HOWTOUSE:any=[];
 @Input()UsesOf:any=[];
 @Input()Benefits: any=[];
 @Input() HowWorks: any=[];
 @Input() Ifmiss:any=[];
 @Input() productName: any;
 @Input() PregnancyInteraction: any;
 @Input() BreastfeedingInteraction: any;
 @Input() DrivingInteraction: any;
 @Input() KidneyInteraction: any;
 @Input() LiverInteraction: any;
 @Input() MANUFACTURER: any;
 @Input()SALTCOMPOSITION: any;
 @Input() STORAGES: any;
 @Input() factbox: any;
 @Input() ColdChain: any=[];
 @Input() productDetailPage: any;
 @Input()manageStock: any;
 @Input() isInStock: any;
 @Input() qty: any;
 @Input() configProductSelected: any;
 
}
